// extracted by mini-css-extract-plugin
export default {"link":"_J-z","disabled":"aK-z"};